module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/layouts/auth-layout/auth-layout.component.html
// module id = ../../../../../src/app/layouts/auth-layout/auth-layout.component.html
// module chunks = main